import React, { useEffect, useState, MouseEvent } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import './scss/login-cover.scss';
import Color from '@/tool/color';
import AppPortal from '@con/app-portal';
import { CloseIcon } from '@styled/icon';
import moStore, { toggleLogin } from '@store/index';

interface IProps {}
interface IState {}

const LoginButton = styled(Button)(() => ({
  width: '120px',
  height: '36px',
  borderRadius: '18px',
  color: Color.fff,
}));

const LoginCover = (props: IProps, state: IState) => {
  const location = useLocation();
  const navi = useNavigate();

  useEffect(() => {
    return () => {};
  }, []);

  const toLogin = () => {
    window.location.href = `/login?url_name=${location.pathname}`;
  };

  return (
    <AppPortal>
      <section className="login-cover">
        <section className="login-0101">
          <p className="title-101"><span>提示</span></p>
          <span className="text-101">请登录后查看</span>
          <p className="bottom-101">
            <LoginButton variant="contained" color="secondary"
              onClick={toLogin}>去登录
            </LoginButton>
          </p>
          <p className="close-101" aria-hidden="true"
            onClick={() => toggleLogin(false)}>
            <CloseIcon color={Color.fff} width={30} height={30} />
          </p>
        </section>
      </section>
    </AppPortal>
  );
};

export default observer(LoginCover);
